import {useEffect, useState} from "react";
import getNavSVGIcon from "../helpers/getNavSVGIcon";
import {checkPermission} from "../helpers/checkPermission";
import {checkMultiplePermissions} from "../helpers/checkMultiplePermissions";

export const useSideBarMenuItems = (permissionActionsList) => {
    const {
        technicalAnalysis,
        fundamentalAnalysis,
        onChainAnalysis,
        tradingViewChart,
        heatMap,
        roleManagement,
        setup,
        notification,
        usersProfile,
        imbalance,
        vmc,
        coins,
    } = permissionActionsList;


    const initialMenuItems = [
        {
            mainMenu: {id: "chart", title: "Chart", icon: getNavSVGIcon('CHARTSQUARE'), href: "/fullchart"},
        },
        {
            mainMenu: {id: "coinList", title: "Coin list", icon: getNavSVGIcon('COIN'), href: "/coinList"},
        },
        {
            mainMenu: {id: "heatMap", title: "HeatMap", icon: getNavSVGIcon('MAP')},
            subMenus: [
                {id: "analysis", title: "Analysis", icon: getNavSVGIcon('MESSAGETEXT'), href: "/"},
                {id: "analysisList", title: "Analysis List", icon: getNavSVGIcon('ROWVERTICAL'), href: "/analysisList"},
                {id: "heatMapList", title: "HeatMap List", icon: getNavSVGIcon('MAP'), href: "/heatMap-list"},
                {id: "notification", title: "Notification", icon: getNavSVGIcon('NOTIFICATION'), href: "/notification"},
                {id: "userList", title: "User List", icon: getNavSVGIcon('PROFILE'), href: "/userList"},
            ],
        },
        {
            mainMenu: {id: "setupList", title: "Setup List", icon: getNavSVGIcon('SETUPSVG')},
            subMenus: [{id: "setupList", title: "Setup list", icon: getNavSVGIcon('ROWVERTICAL'), href: "/setupList"}],
        },
        {
            mainMenu: {id: "tools", title: "Tools", icon: getNavSVGIcon('SETTING')},
            subMenus: [
                {id: "imbalances", title: "Imbalances", icon: getNavSVGIcon('CHARTSQUARE'), href: "/imbalances"},
                {id: "vmc", title: "VM/C", icon: getNavSVGIcon('STRONGBOX'), href: "/vmc"}
            ],
        },
        {
            mainMenu: {id: "settings", title: "Settings", icon: getNavSVGIcon('SETTING')},
            subMenus: [
                {id: "newPair", title: "New Pair", icon: getNavSVGIcon('STRONGBOX'), href: "/newPair"},
                {id: "roles", title: "Roles", icon: getNavSVGIcon('PROFILE'), href: "/roles"}
            ],
        },
    ];

    const [sideBarMenuItems, setSideBarMenuItems] = useState(initialMenuItems);

    useEffect(() => {
        const isValidPer = Object.keys(permissionActionsList).length > 0;

        const menuPermissions = {
            chart: checkPermission(tradingViewChart, ['create', 'read']),
            coinList: checkPermission(coins, ['create', 'read']),

            heatMap: {
                subMenus: {
                    analysis: checkMultiplePermissions([technicalAnalysis, fundamentalAnalysis, onChainAnalysis], ['create']),
                    analysisList: checkMultiplePermissions([technicalAnalysis, fundamentalAnalysis, onChainAnalysis], ['read', 'readall']),
                    heatMapList: checkPermission(heatMap, ['create', 'read', 'readall']),
                    notification: checkPermission(notification, ['read', 'readall']),
                    userList: checkPermission(usersProfile, ['read', 'readall'])
                }
            },

            setupList: {
                subMenus: {
                    setupList: checkPermission(setup, ['read', 'readall'])
                }
            },

            tools: {
                subMenus: {
                    imbalances: checkPermission(imbalance),
                    vmc: checkPermission(vmc)
                }
            },

            settings: {
                subMenus: {
                    newPair: checkPermission(coins, ['create']),
                    roles: checkPermission(roleManagement, ['read', 'readall'])
                }
            }
        };

        if (isValidPer) {
            setSideBarMenuItems(prevItems => {
                let updatedItems = [...prevItems];

                if (menuPermissions?.chart) updatedItems = updatedItems.filter(item => item.mainMenu.id !== "chart");
                if (menuPermissions?.coinList) updatedItems = updatedItems.filter(item => item.mainMenu.id !== "coinList");

                const mainMenuConfigs = [
                    {id: "heatMap", hide: menuPermissions?.heatMap},
                    {id: "setupList", hide: menuPermissions?.setupList},
                    {id: "tools", hide: menuPermissions?.tools},
                    {id: "settings", hide: menuPermissions?.settings}
                ];

                mainMenuConfigs.forEach(({id, hide}) => {
                    if (Object.values(hide?.subMenus).every(value => value)) {
                        updatedItems = updatedItems.filter(item => item.mainMenu.id !== id);
                    } else {
                        updatedItems = updatedItems.map(item => {
                            if (item.mainMenu.id === id) {
                                return {
                                    ...item,
                                    subMenus: item.subMenus.filter(subMenu => !hide.subMenus[subMenu.id])
                                };
                            }
                            return item;
                        });
                    }
                });

                return updatedItems;
            });
        }
    }, [permissionActionsList]);

    return {sideBarMenuItems};
}